// removed by extract-text-webpack-plugin
module.exports = {"relatedAccount":"accountList_hashed__relatedAccount__1BAcS"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/RelatedAccountsList/accountList_hashed.scss
// module id = 1182
// module chunks = 0